// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "Margins-module--limitWidthOnLargeScreens--mECPE";
export var margins = "Margins-module--margins--mWifC";